// extracted by mini-css-extract-plugin
export default {"menu":"NavMenu_menu__JeN4Z"};